import React from 'react';
import autoBind from 'react-autobind';
import textUtil from '@common/helpers/text.utils';
import { Dropdown } from 'react-bootstrap';

//Context
import { withGridContext, ExportTypes } from './grid.factory';

import { getUrlByNameIgnoreCase } from '@common/router/router';
import acValidation from '@common/validators/accessControl.validator';
import reportApi from '@common/components/relatorioGerencial/emissao/service/emissao.service';
import localStorageUtils from '@common/helpers/localStorage.utils';

const SISTEMA_ENUM = {
  SST: 29,
  TB: 21,
  RH: 12,
};

class GridToolbar extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);

    let componentUrl;
    let reportUrl;

    if (!this.props.context.options.noStorage || this.props.context?.options?.routeReport)
      componentUrl =
        this.props.context?.options?.routeReport ?? getUrlByNameIgnoreCase(this.props.context.options.webStorage);

    var repUrl = localStorage.getItem('Report.Grid.Url');
    if (repUrl != null && repUrl != '' && !componentUrl) {
      reportUrl = repUrl;
      setTimeout(() => {
        localStorage.removeItem('Report.Grid.Url');
      }, 1500);
    }

    this.state = {
      openColumnVisibility: false,
      hasReports: true,
      componentUrl: componentUrl,
      reportUrl: reportUrl,
      selectAll: this.props.context.columns.every((x, i) => x.show),
    };

    this.permiteConsultaSQL = localStorageUtils.getItem('PermiteConsultaSQL') == true;
  }

  componentDidMount() {
    $('html').bind('click', (evt) => {
      var target = $(evt.target);
      if (!target.parents('.dropColunas').length) {
        this.handleColumnDropDown(false);
      }
    });
    this.checkHasReports();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.openColumnVisibility !== prevState.openColumnVisibility)
      $('html').bind('click', (evt) => {
        var target = $(evt.target);
        if (!target.parents('.dropColunas').length) {
          this.handleColumnDropDown(false);
        }
      });
  }

  handleColumnDropDown(value) {
    this.setState({ openColumnVisibility: value != undefined ? value : !this.state.openColumnVisibility });
  }

  onClickColumnVisibility(indexColumn) {
    const { context } = this.props;
    const { columns } = context;
    let column = columns[indexColumn];

    return (e) => {
      if (!columns.some((x, i) => x.show && i != indexColumn))
        _alert.warning('Não é possível ocultar todas as colunas');
      else {
        const { checked } = e.target;
        column.show = checked;
        context.setState({ columns });
        this.getDefaultWidthsForColumn(indexColumn);
      }
    };
  }

  onClickColumnVisibilityCheckAllEnable(indexColumn) {
    const { context } = this.props;
    const { columns } = context;
    let column = columns[indexColumn];

    return (e) => {
      const { checked } = e.target;
      column.show = checked;
      if (!columns.every((column) => column.show)) this.setState({ selectAll: false });
      else this.setState({ selectAll: true });

      context.setState({ columns });
      this.getDefaultWidthsForColumn(indexColumn);
    };
  }

  selectAllCheckBox() {
    const { context } = this.props;
    const { columns } = context;
    const newColumns = columns.map((column) => {
      return {
        ...column,
        check: true,
        show: true,
      };
    });
    context.setState({ columns: newColumns });
  }

  deSelectAllCheckBox() {
    const { context } = this.props;
    const { columns } = context;
    const newColumns = columns.map((column) => {
      return {
        ...column,
        check: false,
        show: false,
      };
    });
    context.setState({ columns: newColumns });
  }

  getDefaultWidthsForColumn(index) {
    const { context } = this.props;
    const { columns } = context;

    let column = columns[index];

    if (!column.width || !column.minWidth) {
      const textWidth = textUtil.getTextWidth(column.fieldName) + 40;
      column.width = column.width || (textWidth < 200 ? 200 : textWidth);
      column.minWidth = textWidth;
      context.setState({ columns });
    }
  }

  onPrint(type) {
    return (e) => {
      const { context } = this.props;
      context.printGrid(type);
    };
  }

  onClearFilter() {
    const { context } = this.props;
    context.clearFilters();
  }

  onRefresh() {
    const { context } = this.props;
    const { isFetched } = context;
    if (isFetched) context.refreshData();
  }

  onViewFilter() {
    const { context } = this.props;
    context.setState({ showViewFilter: true }, false);
  }

  onConsultarSQL() {
    const { context, hasFilter } = this.props;

    if (hasFilter) {
      if (!context.isFetched || (!context.columns?.some((x) => x.isFiltered) &&
          context?.data?.dataList == 0 && !context.options?.applySearchOnLoad)
      )
        return _alert.warning('É necessário realizar um filtro para consultar o SQL.');
    }

    context.setState({ showConsultarSQL: true }, false);
  }

  onSaveGridConfiguration() {
    const { context } = this.props;
    context.saveConfigOnService();
  }

  mapOnClickMultipleItem(item) {
    const { context, keepSelectedItensOnPages, itens } = this.props;

    return {
      ...item,
      onClick: (arg) => {
        const allItem = keepSelectedItensOnPages && itens?.length > 0 ? itens : context.data.dataList;
        const selectedItem = context.getSelectedItens();
        item.onClick(selectedItem, allItem);
      },
    };
  }

  isVisible(name) {
    const { toolbar } = this.props.context;
    return !toolbar.tools || toolbar.tools[name];
  }

  async defaultMassDelete(checkedItens) {
    const { keepSelectedItensOnPages, selectedItens } = this.props;

    if (keepSelectedItensOnPages && selectedItens?.length > 0) checkedItens = selectedItens;

    if (checkedItens.length == 0) {
      _alert.warning('É necessário selecionar ao menos um registro para efetuar a deleção em massa.');
    } else {
      const result = await _alert.confirm(
        'Deseja realmente remover os registros selecionados?',
        'Remover registros em massa'
      );
      if (result) {
        const { context } = this.props;
        const { toolbar } = context;
        const { massDelete } = toolbar;
        const { idField, service } = massDelete;

        const listOfIdsToDelete = checkedItens.map((x) => x[idField || 'Id']);

        if (!service) {
          console.error('É necessário definir o serviço para o Mass Delete');
          return;
        }
        await service({ data: listOfIdsToDelete });

        _alert.successNoScroll('Registros removidos com sucesso.');
        context.refreshData();
      }
    }
  }

  async defaultAssociateInMemory(checkedItens) {
    const { keepSelectedItensOnPages, selectedItens } = this.props;

    if (keepSelectedItensOnPages && selectedItens?.length > 0) checkedItens = selectedItens;

    if (checkedItens.length == 0) {
      _alert.warning('É necessário selecionar ao menos um registro para efetuar a associação em massa.');
    } else {
      const result = await _alert.confirm(
        'Deseja realmente associar os registros selecionados?',
        'Associar Registros em Massa'
      );
      if (result) {
        const { context } = this.props;
        const { toolbar } = context;
        const { associateInMemory } = toolbar;
        const { onClick } = associateInMemory;

        checkedItens.forEach((item) => {
          item.isChecked = false;
        });

        onClick(checkedItens);

        await _alert.warningSuccess('Registros associados com sucesso.');
        context.refreshData();
      }
    }
  }

  async defaultDesassociateInMemory(checkedItens) {
    const { keepSelectedItensOnPages, selectedItens } = this.props;

    if (keepSelectedItensOnPages && selectedItens?.length > 0) checkedItens = selectedItens;

    if (checkedItens.length == 0) {
      _alert.warning('É necessário selecionar ao menos um registro para efetuar a desassociação em massa.');
    } else {
      const result = await _alert.confirm(
        'Deseja realmente desassociar os registros selecionados?',
        'Desassociar Registros em Massa'
      );
      if (result) {
        const { context } = this.props;
        const { toolbar } = context;
        const { desassociateInMemory } = toolbar;
        const { onClick } = desassociateInMemory;

        checkedItens.forEach((item) => {
          item.isChecked = false;
        });

        onClick(checkedItens);

        await _alert.warningSuccess('Registros desassociados com sucesso.');
        context.refreshData();
      }
    }
  }

  async defaultDisassociate(checkedItens) {
    if (checkedItens.length == 0) {
      _alert.warning('É necessário selecionar ao menos um registro para efetuar a desassociação em massa.');
    } else {
      const result = await _alert.confirm(
        'Deseja realmente desassociar os registros selecionados?',
        'Desassociar Registros em Massa'
      );
      if (result) {
        const { context } = this.props;
        const { toolbar } = context;
        const { disassociate } = toolbar;
        const { idField, service } = disassociate;

        const listOfIdsToDelete = checkedItens.map((x) => x[idField || 'Id']);

        if (!service) {
          console.error('É necessário definir o serviço');
          return;
        }
        await service({ data: listOfIdsToDelete });
        _alert.success('Registros desassociados com sucesso.');
        context.refreshData();
      }
    }
  }

  async defaultDisassociateNoScroll(checkedItens) {
    if (checkedItens.length == 0) {
      _alert.warning('É necessário selecionar ao menos um registro para efetuar a desassociação em massa.');
    } else {
      const result = await _alert.confirm(
        'Deseja realmente desassociar os registros selecionados?',
        'Desassociar Registros em Massa'
      );
      if (result) {
        const { context } = this.props;
        const { toolbar } = context;
        const { disassociateNoScroll } = toolbar;
        const { idField, service } = disassociateNoScroll;

        const listOfIdsToDelete = checkedItens.map((x) => x[idField || 'Id']);

        if (!service) {
          console.error('É necessário definir o serviço');
          return;
        }
        await service({ data: listOfIdsToDelete });
        _alert.successNoScroll('Registros desassociados com sucesso.');
        context.refreshData();
      }
    }
  }

  async defaultVistarRegistroMass(checkedItens) {
    if (checkedItens.length == 0) {
      _alert.warning('É necessário selecionar ao menos um registro para efetuar o visto em massa.');
    } else {
      const result = await _alert.confirm(
        'Deseja realmente vistar os registros selecionados?',
        'Vistar registros em massa'
      );
      if (result) {
        const { context } = this.props;
        const { toolbar } = context;
        const { vistarRegistroMass } = toolbar;
        const { idField, service } = vistarRegistroMass;

        const listOfIdsToVisto = checkedItens.map((x) => x[idField || 'Id']);

        var teste = {
          ids: listOfIdsToVisto,
        };

        if (!service) {
          console.error('É necessário definir o serviço');
          return;
        }
        await service(teste);
        _alert.success('Registros vistados com sucesso.');
        context.refreshData();
      }
    }
  }

  mapDefaultMultipleItemsActions() {
    const { context } = this.props;
    const { toolbar } = context;

    if (!toolbar) return;
    let {
      massDelete,
      disassociate,
      disassociateNoScroll,
      associateInMemory,
      desassociateInMemory,
      cancel,
      reactivate,
      vistarRegistroMass,
      multipleItensActions,
      actionDefault,
    } = toolbar;

    if (!multipleItensActions) multipleItensActions = [];

    if (actionDefault && !multipleItensActions.some((x) => x.isMassDelete)) {
      toolbar.multipleItensActions = [];
      actionDefault.forEach((element) => {
        if (element) {
          toolbar.multipleItensActions.push(
            {
              title: element.title,
              url: element.url,
              onClick: element.onClick || this.defaultMassDelete.bind(this),
              isMassDelete: true,
            },
            ...multipleItensActions
          );
        }
      });
    }

    if (massDelete && !multipleItensActions.some((x) => x.isMassDelete)) {
      toolbar.multipleItensActions = [
        {
          title: 'Excluir Selecionados',
          url: massDelete.url,
          onClick: massDelete.onClick || this.defaultMassDelete.bind(this),
          isMassDelete: true,
        },
        ...multipleItensActions,
      ];
    }

    if (disassociate && !multipleItensActions.some((x) => x.isDisassociate)) {
      toolbar.multipleItensActions = [
        {
          title: 'Desassociar Selecionados',
          url: disassociate.url,
          onClick: disassociate.onClick || this.defaultDisassociate.bind(this),
          isDisassociate: true,
        },
        ...multipleItensActions,
      ];
    }

    if (disassociateNoScroll && !multipleItensActions.some((x) => x.isDisassociate)) {
      toolbar.multipleItensActions = [
        {
          title: 'Desassociar Selecionados',
          url: disassociateNoScroll.url,
          onClick: disassociateNoScroll.onClick || this.defaultDisassociateNoScroll.bind(this),
          isDisassociate: true,
        },
        ...multipleItensActions,
      ];
    }

    if (cancel && !multipleItensActions.some((x) => x.isCancel)) {
      toolbar.multipleItensActions = [
        {
          title: 'Cancelar Selecionados',
          url: cancel.url,
          onClick: cancel.onClick || this.defaultCancel.bind(this),
          isCancel: true,
        },
        ...multipleItensActions,
      ];
    }

    if (reactivate && !multipleItensActions.some((x) => x.isReactivate)) {
      toolbar.multipleItensActions = [
        {
          title: 'Reativar Selecionados',
          url: reactivate.url,
          onClick: reactivate.onClick || this.defaultReactivate.bind(this),
          isReactivate: true,
        },
        ...multipleItensActions,
      ];
    }

    if (cancel && !multipleItensActions.some((x) => x.isCancel)) {
      toolbar.multipleItensActions = [
        {
          title: 'Cancelar Selecionados',
          url: cancel.url,
          onClick: cancel.onClick || this.defaultCancel.bind(this),
          isCancel: true,
        },
        ...multipleItensActions,
      ];
    }

    if (associateInMemory && !multipleItensActions.some((x) => x.isAssociarEmMemoria)) {
      toolbar.multipleItensActions = [
        {
          title: 'Associar Selecionados',
          url: associateInMemory.url,
          onClick: this.defaultAssociateInMemory.bind(this),
          isAssociarEmMemoria: true,
        },
        ...multipleItensActions,
      ];
    }

    if (desassociateInMemory && !multipleItensActions.some((x) => x.isDesassociarEmMemoria)) {
      toolbar.multipleItensActions = [
        {
          title: 'Desassociar Selecionados',
          url: desassociateInMemory.url,
          onClick: this.defaultDesassociateInMemory.bind(this),
          isDesassociarEmMemoria: true,
        },
        ...multipleItensActions,
      ];
    }

    if (vistarRegistroMass && !multipleItensActions.some((x) => x.isVistarRegistroMass)) {
      toolbar.multipleItensActions = [
        {
          title: 'Vistar Selecionados',
          url: vistarRegistroMass.url,
          onClick: vistarRegistroMass.onClick || this.defaultVistarRegistroMass.bind(this),
          isVistarRegistroMass: true,
        },
        ...multipleItensActions,
      ];
    }
  }

  onReport() {
    this.props.onReportModal(this.state.componentUrl);
  }

  async checkHasReports() {
    const { options } = this.props.context;
    var hasReport = false;

    try {
      const idSistema = sessionStorage.getItem('SISTEMA');
      const appConfig = window.appConfig;

      if (
        (idSistema == SISTEMA_ENUM.SST && appConfig.useReportDesignerSST) ||
        (idSistema == SISTEMA_ENUM.TB && appConfig.useReportDesignerTB)
      ) {
        if (this.state.componentUrl) {
          const result = await reportApi.getHasReports(this.state.componentUrl);
          hasReport = result.data.HasReport;

          if (!hasReport && reportUrl) {
            const resultReportUrl = await reportApi.getHasReports(this.state.reportUrl);

            hasReport = resultReportUrl.data.HasReport;

            if (hasReport) this.setState({ componentUrl: reportUrl });
          }
        } else {
          hasReport = false;
        }
      }
    } catch {}
    this.setState({
      hasReports: hasReport,
    });

    if (hasReport) {
      options.isNotCheckable = false;
    }
  }

  render() {
    const { context, disableNew } = this.props;
    const { toolbar, options } = context;
    const { noStorage } = options;
    const { openColumnVisibility } = this.state;

    this.mapDefaultMultipleItemsActions();
    const multipleItensActions = toolbar.multipleItensActions
      ? toolbar.multipleItensActions.map(this.mapOnClickMultipleItem)
      : undefined;

    const { customButtons } = toolbar;

    return (
      <div className="action-bar clearfix" style={{ marginTop: '7px' }}>
        <div>
          <div className="float-right">
            {multipleItensActions &&
              this.renderDropDown({
                title: 'Ações em múltiplos itens',
                icon: 'fa fa-tasks',
                itens: multipleItensActions,
              })}

            {customButtons && customButtons.length > 0 && customButtons.map(this.renderCustomButton)}

            {this.isVisible('verFiltro') &&
              this.renderButton({
                title: 'Ver Filtro',
                icon: 'fa fa-filter',
                onClick: this.onViewFilter,
              })}

            {toolbar.new &&
              ((!toolbar.new.route && !toolbar.new.url) ||
                acValidation.checkPermissionsByName(toolbar.new.route) ||
                acValidation.checkPermissionByUrl(toolbar.new.url)) &&
              this.renderButton({
                title: 'Novo',
                icon: 'fa fa-plus',
                type: 'button',
                onClick: toolbar.new.onClick,
                disabled: disableNew,
              })}

            {this.isVisible('atualizar') &&
              this.renderButton({
                title: 'Atualizar',
                icon: 'fas fa-sync-alt',
                onClick: this.onRefresh,
              })}

            {!toolbar.staticGrid &&
              this.isVisible('salvarConfiguracao') &&
              this.renderButton({
                title: 'Salvar Configuração',
                disabled: noStorage,
                icon: 'fa fa-cog',
                onClick: this.onSaveGridConfiguration,
              })}

            {this.isVisible('exportar') &&
              this.props.onPrint &&
              this.renderDropDown({
                title: 'Imprimir Resultado',
                icon: 'fas fa-print',
                itens: [
                  {
                    title: 'XLS',
                    onClick: this.onPrint(ExportTypes.XLS),
                  },
                  {
                    title: 'PDF Paisagem',
                    onClick: this.onPrint(ExportTypes.PDFLandscape),
                  },
                  {
                    title: 'PDF Retrato',
                    onClick: this.onPrint(ExportTypes.PDFPortrait),
                  },
                  {
                    title: 'TXT',
                    onClick: this.onPrint(ExportTypes.TXT),
                  },
                ],
              })}

            {this.state.hasReports &&
              this.renderButton({
                title: 'Relatórios',
                icon: 'fas fa-caret-square-down',
                onClick: this.onReport,
              })}

            {(this.isVisible('consultarSQL') && !toolbar.staticGrid && this.permiteConsultaSQL && this.props?.context?.options?.service) &&
              this.renderButton({
                title: 'Consultar SQL',
                icon: 'far fa-clipboard-list-check',
                onClick: this.onConsultarSQL,
              })}

            {this.isVisible('limpar') &&
              this.renderButton({
                title: 'Limpar Filtros',
                icon: 'fas fa-eraser',
                onClick: this.onClearFilter,
              })}

            {this.isVisible('colunas') && (
              <div className="btn-group dropColunas dropleft">
                <a
                  className="btn-custom dropdown-toggle"
                  aria-haspopup="true"
                  onClick={this.handleColumnDropDown}
                  title={'Colunas Visíveis'}
                >
                  <i className={`pointer-events-none fa fa-eye`} />
                </a>
                <ul
                  className="dropdown-menu  filter hideShowColumns open"
                  role="menu"
                  style={{ display: openColumnVisibility ? 'block' : 'none' }}
                >
                  <li className="filterLine">
                    <h5>Colunas Visíveis</h5>
                  </li>

                  {this.props.context.options.selectAllEnable && (
                    <li className="filterLine">
                      <label className="filterColunm" title={'Marcar/Desmarcar Todos'}>
                        <input
                          type="checkbox"
                          className="all"
                          checked={this.state.selectAll}
                          onChange={() => {
                            this.setState({ selectAll: !this.state.selectAll });
                            if (!this.state.selectAll) this.selectAllCheckBox();
                            else this.deSelectAllCheckBox();
                          }}
                        />
                        Selecionar Todos
                      </label>
                    </li>
                  )}

                  {context.columns.map((column, indexColumn) => (
                    <li className="filterLine" key={indexColumn}>
                      <label>
                        <input
                          className="mr-1"
                          type="checkbox"
                          checked={column.show || false}
                          onChange={
                            this.props.context.options.selectAllEnable
                              ? this.onClickColumnVisibilityCheckAllEnable(indexColumn)
                              : this.onClickColumnVisibility(indexColumn)
                          }
                        />
                        {column.fieldName}
                      </label>
                      {column.isFiltered && (
                        <label className="float-right">
                          <i className="fa fa-filter" />
                        </label>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderCustomButton(item, index) {
    if (item.hide) return;

    switch (item.type) {
      case 'button':
        var controle = true;
        if (item.route) controle = acValidation.checkPermissionsByName(item.route);
        if (item.url) controle = acValidation.checkPermissionByUrl(item.url);
        return controle ? this.renderButton(item, index) : null;
      case 'dropdown':
        return this.renderDropDown(item, index);
    }
  }

  renderButton(item, index) {
    return (
      <>
        {item.type == 'button' ? (
          <button
            type="button"
            className="btn btn-primary btn-custom"
            disabled={item.disabled}
            title={item.title}
            onClick={item.onClick}
            key={index}
            style={{ marginTop: '0px', cursor: item.disabled ? 'default' : 'pointer' }}
          >
            <i className={`pointer-events-none ${item.icon}`} />
          </button>
        ) : (
          !item?.disabled && (
            <a className="btn-custom" onClick={item.onClick} title={item.title} key={index}>
              <i className={`pointer-events-none ${item.icon}`} />
            </a>
          )
        )}
      </>
    );
  }

  renderDropDown(item, index) {
    const filterItens = item.itens.filter((x) => !x.url || acValidation.checkPermissionByUrl(x.url));

    if (filterItens.length == 0) return null;

    return (
      <Dropdown key={index}>
        <Dropdown.Toggle className="btn-custom dropdown-toggle-custom" title={item.title}>
          {item.icon ? (
            <i className={`pointer-events-none-custom-grid ${item.icon}`} />
          ) : (
            <span className="pointer-events-none-custom-grid">{item.title}</span>
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {filterItens.map((child, indexChid) => (
            <Dropdown.Item key={indexChid} onClick={child.onClick}>
              {child.title}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default withGridContext(GridToolbar);
